/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Lucky_Panther_DigInputs */

const fr_bright_lucky_panther_dig = /** @type {(inputs: Bright_Lucky_Panther_DigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer MFA`)
};

/**

* @param {Bright_Lucky_Panther_DigInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bright_lucky_panther_dig = /** @type {((inputs?: Bright_Lucky_Panther_DigInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Lucky_Panther_DigInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bright_lucky_panther_dig(inputs)
});